module.exports = __webpack_public_path__ + "accb059114cadb8d83525c96524c5e7b.svg";